import { addressData } from '@/redux/features/addressSlice'
import { cartData, setCartCount } from '@/redux/features/cartSlice'
import { addUser, setSessionId } from '@/redux/features/userSlice'
import axios from 'axios'
import { ErrorMessage, Form, Formik } from 'formik'
import nookies from 'nookies'
import { use, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useImmer } from 'use-immer'
import * as Yup from 'yup'
import axiosProvider from '../../lib/AxiosProvider'
import { _exception } from '../../lib/exceptionMessage'
import {
  getBaseUrl,
  getDeviceId,
  getRefreshToken,
  getSessionId,
  showToast
} from '../../lib/GetBaseUrl'
import { _phoneNumberRegex_, _positiveInteger_ } from '../../lib/Regex'
import InputComponent from '../base/InputComponent'
import TextError from '../base/TextError'
import Loader from '../Loader'
import { InputOtp } from '@heroui/react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { isValidPhoneNumber } from 'libphonenumber-js'

const LoginViaOtp = ({ newMobile, toggleForm, onClose, newAddress }) => {
  const baseUrl = getBaseUrl()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [mobile, setMobile] = useImmer(false)
  const formikRef = useRef(null)
  const mobileInputRef = useRef(null)
  const mySessionId = useSelector((state) => state?.user?.sessionId)
  const initialValues = {
    mobileNo: newMobile || '',
    otp: ''
  }
  const accessToken = getRefreshToken()
  const [cartId, setCartId] = useState()
  const { cart } = useSelector((state) => state?.cart)
  const [modal, setModal] = useState(false)
  const [resendTimer, setResendTimer] = useState(0)

  useEffect(() => {
    if (newMobile && formikRef.current) {
      formikRef.current.submitForm()
    }
  }, [newMobile])

  useEffect(() => {
    if (resendTimer <= 0) return
    const t = setInterval(() => setResendTimer((s) => s - 1), 1000)
    return () => clearInterval(t)
  }, [resendTimer])

  useEffect(() => {
    const handleFocus = () => {
      if (!mobile)
        if (mobileInputRef.current) {
          mobileInputRef.current.focus()
        }
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('load', handleFocus)

      return () => {
        window.removeEventListener('load', handleFocus)
      }
    }
  }, [mobile])

  const validationSchema = Yup.object().shape({
    // mobileNo: Yup.string()
    //   .matches(_phoneNumberRegex_, "Please enter valid mobile number")
    //   .required("Mobile number is required"),
    mobileNo: Yup.string()
      .required('Mobile number is required')
      .test('is-valid-phone', 'Invalid phone number', (value) =>
        isValidPhoneNumber(value || '')
      ),
    otp: Yup.string().when('showOtpForm', {
      is: (value) => value,
      then: () => Yup.string().required('Otp is required'),
      otherwise: () => Yup.string().notRequired()
    })
  })

  const getCartCount = async (userId) => {
    try {
      if (userId?.length) {
        const res = await axiosProvider({
          method: 'GET',
          endpoint: `Cart/bysessionId?sessionId=${userId}`
        })
        dispatch(setCartCount(res?.data?.pagination?.recordCount))
      }
    } catch (error) {
      showToast(dispatch, {
        data: { code: 204, message: _exception?.message }
      })
    }
  }

  //   const onSubmit = async (
  //     values,
  //     setFieldValue,
  //     endpoint,
  //     method = 'put',
  //     resetForm
  //   ) => {
  //     const config = {
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     }
  //     try {
  //       setLoading(true)
  //       const response = await axios[method](
  //         `${baseUrl}${endpoint}`,
  //         values,
  //         config
  //       )
  //       setLoading(false)

  //       if (response?.data?.code === 200) {
  //         if (endpoint?.includes('GenerateMobileOtp')) {
  //           setMobile(true)
  //           setFieldValue('showOtpForm', true)
  //         } else {
  //           showToast(dispatch, response)
  //           setModal(true)
  //           getCartCount(response?.data?.currentUser?.userId)
  //           localStorage.removeItem('hk-compare-data')
  //           let userId = response?.data?.currentUser?.userId
  //           nookies.set(null, 'userToken', response?.data?.tokens?.accessToken, {
  //             path: '/'
  //           })
  //           nookies.set(
  //             null,
  //             'refreshToken',
  //             response?.data?.tokens?.refreshToken,
  //             { path: '/' }
  //           )
  //           nookies.set(null, 'userId', response?.data?.currentUser?.userId, {
  //             path: '/'
  //           })

  //           if (mySessionId) {
  //             const responseSession = await axiosProvider({
  //               method: 'PUT',
  //               endpoint: 'Cart/UpdateSession',
  //               queryString: `?UserId=${userId}&SessionId=${mySessionId}&CartId=${
  //                 cartId ? cartId : 0
  //               }`
  //             })
  //             if (responseSession?.status === 200) {
  //               // nookies.set(null, 'sessionId', userId, { path: '/' });
  //               dispatch(setSessionId(userId))
  //             }
  //           }

  //           dispatch(
  //             addUser({
  //               user: response?.data?.currentUser,
  //               userToken: response?.data?.tokens?.accessToken,
  //               refreshToken: response?.data?.tokens?.refreshToken,
  //               deviceId: getDeviceId()
  //             })
  //           )

  //           resetForm({ values: '' })

  //           // Handle Addresss api
  //           const responseAddress = await axiosProvider({
  //             method: 'GET',
  //             endpoint: 'Address/byUserId',
  //             queryString: `?userId=${userId}`
  //           })
  //           if (responseAddress?.data?.code === 200) {
  //             const setDefaultAddress =
  //               response?.data?.data?.length > 0 &&
  //               response?.data?.data?.find((item) => item?.setDefault)
  //             if (response?.data?.data?.length === 1) {
  //               dispatch(
  //                 cartData({ ...cart, deliveryData: response?.data?.data[0] })
  //               )
  //             } else if (setDefaultAddress?.id) {
  //               dispatch(cartData({ ...cart, deliveryData: setDefaultAddress }))
  //             }
  //             dispatch(addressData(responseAddress?.data?.data))
  //           }

  //           try {
  //             const responseWishlist = await axiosProvider({
  //               method: 'GET',
  //               endpoint: 'Wishlist/byUserId',
  //               queryString: `?userId=${userId}&pageIndex=0&pageSize=0`
  //             })

  //             if (responseWishlist?.data?.code === 200) {
  //               const wishlistData = responseWishlist?.data?.data?.map(
  //                 (item) => ({
  //                   productId: item?.products?.guid, // The Product GUID
  //                   wishlistId: item?.id // The Wishlist Item ID
  //                 })
  //               )
  //               dispatch(setWishlist(wishlistData))
  //               localStorage.setItem('wishlist', JSON.stringify(wishlistData)) // Also update localStorage
  //             }
  //           } catch (error) {
  //             console.error('Wishlist fetch failed:', error)
  //           }

  //           setFieldValue('setOtpForm', false)
  //           onClose()
  //         }
  //       }

  //       showToast(dispatch, response)
  //     } catch {
  //       setLoading(false)
  //       showToast(dispatch, {
  //         data: { code: 204, message: _exception?.message }
  //       })
  //     }
  //   }

  // const handleChangeButton = () => {
  //   document.getElementById('mobileNo').focus()
  //   setMobile(false)
  // }

  const handleResendOtp = async (values, setFieldValue) => {
    if (resendTimer > 0) return
    await onSubmit(
      { mobileNo: values.mobileNo },
      setFieldValue,
      'Account/Customer/GenerateMobileOtp',
      'put'
    )
    setResendTimer(30) // 30s cooldown, adjust as needed
  }

  const onSubmit = async (
    values,
    setFieldValue,
    endpoint,
    method = 'put',
    resetForm
  ) => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    try {
      setLoading(true)
      const response = await axios[method](
        `${baseUrl}${endpoint}`,
        values,
        config
      )
      setLoading(false)

      if (response?.data?.code === 200) {
        if (endpoint?.includes('GenerateMobileOtp')) {
          setMobile(true)
          setFieldValue('showOtpForm', true)
          showToast(dispatch, response)
        } else {
          showToast(dispatch, response)
          setModal(true)
          getCartCount(response?.data?.currentUser?.userId)
          localStorage.removeItem('hk-compare-data')
          let userId = response?.data?.currentUser?.userId
          nookies.set(null, 'userToken', response?.data?.tokens?.accessToken, {
            path: '/'
          })
          nookies.set(
            null,
            'refreshToken',
            response?.data?.tokens?.refreshToken,
            { path: '/' }
          )
          nookies.set(null, 'userId', response?.data?.currentUser?.userId, {
            path: '/'
          })

          if (mySessionId) {
            const responseSession = await axiosProvider({
              method: 'PUT',
              endpoint: 'Cart/UpdateSession',
              queryString: `?UserId=${userId}&SessionId=${mySessionId}&CartId=${
                cartId ? cartId : 0
              }`
            })
            if (responseSession?.status === 200) {
              dispatch(setSessionId(userId))
            }
          }

          dispatch(
            addUser({
              user: response?.data?.currentUser,
              userToken: response?.data?.tokens?.accessToken,
              refreshToken: response?.data?.tokens?.refreshToken,
              deviceId: getDeviceId()
            })
          )

          resetForm({ values: '' })

          if (newAddress) {
            try {
              const addressResponse = await axiosProvider({
                method: 'POST',
                endpoint: 'Address',
                data: { ...newAddress, userId }
              })

              if (addressResponse?.data?.code !== 200) {
                showToast(dispatch, addressResponse)
              }
            } catch (error) {
              console.error('Address save error:', error)
              showToast(dispatch, {
                data: { code: 204, message: _exception?.message }
              })
            }
          }

          const responseAddress = await axiosProvider({
            method: 'GET',
            endpoint: 'Address/byUserId',
            queryString: `?userId=${userId}`
          })
          if (responseAddress?.data?.code === 200) {
            const setDefaultAddress =
              response?.data?.data?.length > 0 &&
              response?.data?.data?.find((item) => item?.setDefault)
            if (response?.data?.data?.length === 1) {
              dispatch(
                cartData({ ...cart, deliveryData: response?.data?.data[0] })
              )
            } else if (setDefaultAddress?.id) {
              dispatch(cartData({ ...cart, deliveryData: setDefaultAddress }))
            }
            dispatch(addressData(responseAddress?.data?.data))
          }

          //   try {
          //     const responseWishlist = await axiosProvider({
          //       method: 'GET',
          //       endpoint: 'Wishlist/byUserId',
          //       queryString: `?userId=${userId}&pageIndex=0&pageSize=0`
          //     })

          //     if (responseWishlist?.data?.code === 200) {
          //       const wishlistData = responseWishlist?.data?.data?.map(
          //         (item) => ({
          //           productId: item?.products?.guid,
          //           wishlistId: item?.id
          //         })
          //       )
          //       dispatch(setWishlist(wishlistData))
          //       localStorage.setItem('wishlist', JSON.stringify(wishlistData))
          //     }
          //   } catch (error) {
          //     console.error('Wishlist fetch failed:', error)
          //   }

          setFieldValue('setOtpForm', false)
          onClose()
        }
        return
      }

      // Non-200 response
      showToast(dispatch, response)
      if (endpoint?.includes('GenerateMobileOtp') && toggleForm) {
        toggleForm('signup')
      }
    } catch {
      setLoading(false)
      showToast(dispatch, {
        data: { code: 204, message: _exception?.message }
      })
      if (endpoint?.includes('GenerateMobileOtp') && toggleForm) {
        toggleForm('signup')
      }
    }
  }

  //   useEffect(() => {
  //     if (accessToken !== null) {
  //       onClose()
  //     }
  //   }, [accessToken])

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      let cartId = localStorage.getItem('cartId')
      setCartId(cartId)
    }
  }, [])

  return (
    <>
      {loading && <Loader />}
      {/* <div className="login-otp-main">
        <h1 className="forgot-title">Login Via Otp</h1>
        <button className="forgot-back-btn" onClick={() => toggleForm("login")}>
          <i className="m-icon back-icon"></i>
          Go Back
        </button>
      </div> */}

      <Formik
        innerRef={formikRef}
        validateOnChange={false}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setFieldValue, resetForm }) => {
          let endpoint = values?.showOtpForm
            ? 'Account/Customer/LoginViaOtp'
            : 'Account/Customer/GenerateMobileOtp'
          let method = values?.showOtpForm ? 'post' : 'put'
          let data = values?.showOtpForm
            ? {
                ...values,
                deviceId: getDeviceId()
              }
            : values
          onSubmit(data, setFieldValue, endpoint, method, resetForm)
        }}
      >
        {({ values, setFieldValue, touched, submitForm }) => (
          <Form>
            <div className="mp-mobile-otp">
              {mobile !== false && (
                <button
                  onClick={() => {
                    document.getElementById('mobileNo').focus()
                    setMobile(false)
                    setFieldValue('showOtpForm', false)
                    setFieldValue('otp', '')
                  }}
                  id="changeButton"
                  type="button"
                >
                  Change
                </button>
              )}
              {/* <InputComponent
                disabled={mobile ? true : false}
                ref={mobileInputRef}
                required
                labelClass={"sign-com-label"}
                labelText={"Mobile Number for OTP"}
                MainHeadClass={"forgot-mobile"}
                type="number"
                name="mobileNo"
                id="mobileNo"
                onChange={(e) => {
                  const inputValue = e?.target?.value;
                  const fieldName = e?.target?.name;
                  const isValid = _phoneNumberRegex_.test(inputValue);
                  if (!inputValue || isValid) {
                    setFieldValue(fieldName, inputValue);
                  }
                }}
                value={values.mobileNo}
              /> */}
              <label>
                Contact Number for OTP
                <span className="pv-label-red-required">*</span>
              </label>
              <PhoneInput
                country={'in'}
                value={values.mobileNo}
                disabled={Boolean(newMobile)}
                onChange={(value) => {
                  setFieldValue('mobileNo', `+${value}`)
                }}
                inputProps={{
                  name: 'mobileNo',
                  required: true,
                  onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()

                      document.querySelector('button[type="submit"]')?.click()
                    }
                  }
                }}
                enableSearch={true}
                containerStyle={{ width: '100%' }}
                inputStyle={{ width: '100%' }}
              />
              <ErrorMessage name="mobile" component={TextError} />
            </div>
            {mobile && (
              // <div className="mp-mobile-otp">
              //   <p className="otp-mobile-num">Enter the Otp.</p>
              //   <InputComponent
              //     labelClass={"sign-com-label"}
              //     MainHeadClass={"forgot-mobile"}
              //     type={"text"}
              //     name={"otp"}
              //     id={"otp"}
              //     autoFocus
              //     onChange={(e) => {
              //       const inputValue = e?.target?.value;
              //       const fieldName = e?.target?.name;
              //       const isValid = _positiveInteger_.test(inputValue);
              //       if (!inputValue || isValid) {
              //         setFieldValue(fieldName, inputValue);
              //       }
              //     }}
              //     value={values.otp}
              //     maxLength={"6"}
              //   />
              //   {ErrorMessage.otp && touched.otp && (
              //     <ErrorMessage name="otp" component={TextError} />
              //   )}
              // </div>

              <div className="input-wrapper-main">
                <label htmlFor="otp" className="form-c-label sign-com-label">
                  Enter OTP <span className="pv-label-red-required">*</span>
                </label>
                <InputOtp
                  autoFocus
                  style={{
                    '--nextui-focus-color': 'black',
                    '--nextui-primary': 'black'
                  }}
                  // classNames={{
                  //   base: "w-full",
                  //   segmentWrapper: "w-full gap-2 sm:gap-3 py-0",
                  //   segment:
                  //     "text-black flex-1 min-w-0 aspect-square bg-white border border-[#CBD5E1] [&:focus]:!outline-none [&:focus]:!shadow-[0_0_0_1px_black] [&:focus]:!border-black data-[active=true]:!outline-none data-[active=true]:!border-black data-[active=true]:!shadow-[0_0_0_1px_black] data-[active=true]:scale-1",
                  //   helperWrapper: "font-normal",
                  //   errorMessage: "text-red-500",
                  // }}
                  classNames={{
                    base: 'w-full px-[2px]', // small padding so edge shadows aren't clipped
                    segmentWrapper:
                      'w-full gap-2 sm:gap-3 py-0 overflow-visible',
                    segment:
                      'text-black flex-1 min-w-0 aspect-square bg-white border border-[#C20A14]',
                    helperWrapper: 'font-normal',
                    errorMessage: 'text-red-500'
                  }}
                  minLength={false}
                  length={6}
                  required={false}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, '')
                    setFieldValue('otp', numericValue)
                  }}
                  onComplete={(value) => {
                    const numericValue = value.replace(/\D/g, '')
                    setFieldValue('otp', numericValue)
                    //   if (numericValue.length === 6) {
                    //     setTimeout(() => {
                    //       document
                    //         .querySelector('button[type="submit"]')
                    //         .click()
                    //     }, 100)
                    //   }
                  }}
                />
                <ErrorMessage name={'otp'} component={TextError} />
                <div className="flex items-center gap-1.5 mt-2.5 text-sm">
                  <span className="text-gray-500">
                    Didn't receive the code?
                  </span>
                  {resendTimer > 0 ? (
                    <span className="text-gray-400 font-medium">
                      Resend OTP in {resendTimer}s
                    </span>
                  ) : (
                    <button
                      type="button"
                      disabled={loading}
                      onClick={() => handleResendOtp(values, setFieldValue)}
                      className="text-[#C20A14] font-semibold underline underline-offset-2 hover:text-[#a10812] disabled:text-red-200 disabled:no-underline disabled:cursor-not-allowed"
                    >
                      Resend OTP
                    </button>
                  )}
                </div>
              </div>
            )}
            <div className="send-rest-forgot">
              <button
                type="submit"
                className="get-otp-login"
                disabled={loading}
              >
                {mobile ? 'Verify OTP' : 'Generate OTP'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default LoginViaOtp
